export default function getPriceReducer
    (state = {error: null, success: null, processing: false}, action) {

    switch (action.type) {
        case 'GET_PRICE_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'GET_PRICE_ERROR':
            return {...state, ...{error: action.error}};

        case 'GET_PRICE_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default:
            return state;
    }
}